﻿import common = require("../common");
import Page = require("./components/Page");
import MessagesManager = require("./components/MessagesManager");
import Notifications = require("./components/Notifications");
import Pooler = require("../core/Pooler");
import Navigation2 = require("./components/Navigation2");

export = (context => {
    context.bag = {};
    context.culture = context.culture || {} as common.ICultureContext;
    context.culture.get = (defaultCulture?: common.Cultures) =>
        context.culture && context.culture.name
            ? common.Cultures[context.culture.name] ?? (function () { throw "La culture '" + context.culture.name + "' n'existe pas."; })()
            : defaultCulture ?? common.Cultures.fr;
    context.components = {
        items: {},
        add: (webComponent: common.IWebComponent) => {
            //Bug IE11
            //https://stackoverflow.com/questions/25140723/constructor-name-is-undefined-in-internet-explorer
            const t = (webComponent as any).getTypeName();
            if (context.components.items[t])
                context.components.items[t].push(webComponent);
            else
                context.components.items[t] = [webComponent];
            return webComponent;
        },
        /** f: retourner TRUE pour faire un 'break'. */
        doForEarch: (f: (type: string, webComponent: common.IWebComponent) => void | boolean, skipNullEntries?: boolean) => {
            if (!f) throw "L'argument 'f' est NULL.";
            skipNullEntries = skipNullEntries !== false;//default=TRUE
            for (let k in context.components.items || {}) {
                const components = context.components.items[k] as common.IWebComponent[];
                for (let i = 0; i < (components || []).length; i++) {
                    const c = components[i];
                    if ((c || !skipNullEntries) && f(k, c))
                        return;
                }
            }
        },
        getByType: (type: string, skipNullEntries?: boolean) => {
            skipNullEntries = skipNullEntries !== false;//default=TRUE
            if (!type) return [];
            const all = context.components.items[type] ?? [];
            const res = [];
            for (let i = 0; i < all.length; i++) {
                const c = all[i];
                if (c || !skipNullEntries)
                    res.push(c);
            }
            return res;
        },
        getPage: () => {
            return context.components.items["Page"][0] as Page;
        },
        getMessagesManager: () => {
            return context.components.getPage().getMessagesManager() as MessagesManager;
        },
        getNotifications: () => {
            return context.components.getPage().getNotifications() as Notifications;
        },
        getMainNavigation: () => {
            return context.components.getPage().getMainNavigation() as Navigation2;
        },
        getPooler: () => {
            return context.components.getPage().getPooler() as Pooler;
        }
    } as common.IComponentsContext;

    return context;
})(((window as any).currentContext || {}) as common.IContext);